<template>
  <div>
    <vx-card id="consultationDataContainer" :title="$tc('schedules')" class="mb-8 vs-con-loading__container">
      <calendar-month :dates="dates" @select="getSchedule" @dateChange="fetchSchedules" />
    </vx-card>
  </div>
</template>

<script>

import Schedule from '@/models/Schedule'
import CalendarMonth  from '@/components/calendar/ScheduleCalendar/CalendarMonth'
import Utils from '@/helpers/utils'

export default {
  name: 'User.Schedules',
  components: {
    CalendarMonth
  },
  data () {
    return {
      dates: [],
      date: '',
      modals: {
        update: false
      }
    }
  },
  mounted () {
    this.fetchSchedules()
    this.$windowOpenerHelper.listenToPopUpMessage('reload_notification_calendar', this.fetchSchedules)
  },
  methods: {
    async fetchSchedules (date) {
      if (date !== undefined && date !== '') {
        this.date = date
      }
      this.$vs.loading({container: '#consultationDataContainer'})
      const response = await Schedule.all({ date: this.date })
      this.dates = response.data.data
      this.$vs.loading.close('#consultationDataContainer > .con-vs-loading')
    },
    updateScheduleModal () {
      this.modals.update = true
    },
    getSchedule (date) {
      Utils.openPopUp(this.$store.getters.ctiPopUp, 'update-schedule', {date}, this.updateScheduleModal)
    }
  }
}
</script>

<style lang="scss">

</style>
